import { useAuth } from "@/auth/AuthProvider";
import { useDocumentRealtime } from "@/hooks/documents";
import { useAgentSubscriptionSync } from "@/hooks/agent/useAgentSubscriptionSync";
import { updateDocumentParsingProgress } from "@/hooks/documents/useDocumentParsingStatus";
import { useInboxViewReportJobs } from "@/hooks/inboxView/useInboxViewReportJobs";

/**
 * Global Realtime listeners container
 * Registers all realtime event listeners for the application
 * Can be extended with additional listeners as needed
 */
export const GlobalRealtimeListeners = () => {
  const { user } = useAuth();

  // Agent subscription sync listener - invalidates agent queries when subscription changes
  useAgentSubscriptionSync();

  // Document realtime updates listener - handles document status changes and kb updates
  useDocumentRealtime({
    showToast: true,
    userId: user?.id,
    invalidateAgentQueries: true,
    onDocumentUpdate: (payload) => {
      // Update progress for extraction updates so DocumentDetailsDrawer shows real-time progress
      if (payload.progress !== undefined && payload.process_type === 'extraction_started') {
        updateDocumentParsingProgress(payload.document_id, payload.progress);
      }
    },
  });

  // View PDF downloads and test report sends - finishes the ones this tab started
  useInboxViewReportJobs();

  // Additional listeners can be added here as the app grows
  // e.g., useLeadUpdates(), useConversationUpdates(), etc.

  return null;
};
